/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;flex-shrink:0}@media screen and (min-width:768px){[_nghost-%COMP%]{padding-inline:1.25rem}}.button[_ngcontent-%COMP%]{background:radial-gradient(56.14% 210.71% at 108.08% 0,#bbf55c 0,#00cad4 37%,#0078ff 100%);border-radius:0 20px 20px 0;border:none;color:#fff;padding:8px 16px 8px 32px;font-size:15px;line-height:1;cursor:pointer;margin-left:-24px}.avatar[_ngcontent-%COMP%]{z-index:1;width:38px;cursor:pointer}"];
export { styles as styles };
//# sourceMappingURL=chat-bot-button.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/header/chat-bot-button/chat-bot-button.component.scss.shim.ngstyle.js
// module id = 1463
// module chunks = 27 28 29